<div class="modal-header bg-light">
    <div class="modal-title pull-left">
        <h5 class="mb-0 font-weight-bold">Paste Excel Financials</h5>
    </div>

    <button id="ist-excel-paste-close" type="button" class="close pull-right align-self-center" aria-label="Close" (click)="decline()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body bg-light">

    <div class="text-center color--black">
        <div>
            With this window open press Ctrl+V to paste your copied financials from your
            <a role="button" id="ist-excel-paste-sample-file-btn" class="color--blue" (click)="downloadSampleFile()">template.</a> <br>
            <br>
            For more information on how to copy/paste financials into <br>
            Valzy download our <a id="ist-excel-paste-docs-download-url" role="button" class="color--blue" [href]="docsDownloadUrl">How To</a>.
        </div>
    </div>

</div>
<div class="modal-footer bg-light">
    <button type="button" id="ist-excel-paste-cancel-btn" class="button secondary__button large__button" (click)="decline()">Cancel</button>
</div>